import { render, staticRenderFns } from "./TextTool.vue?vue&type=template&id=1d42f2db"
import script from "./TextTool.vue?vue&type=script&lang=ts"
export * from "./TextTool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports